// extracted by mini-css-extract-plugin
export default {"imageCard":"X1XpTe1ipFRaWZF8cT6b"};